import { Component } from '@angular/core';
import { Icon } from '../icon';

@Component({
  selector: 'iconmonstr-cancel',
  templateUrl: './cancel.component.html',
})
export class CancelComponent extends Icon {
}
